import { a, useChain, useSpringRef, useTrail } from "@react-spring/web";
import { SidebarLayoutShowDesktop, SidebarLayoutShowMobile } from "../../layout/SideBarLayout";
import { PageTitle } from "../ReusableStyledComponents/PageTitle";
import { V3OpenSettings } from "../V3OpenSettings";
import { STBMobileRightSidePanel, STBWRapper, SettingsTopBarTitle } from "./SettingsTopBar.styles";
import React, { type JSX } from "react";

interface SettingsTopBarProps {
    isBusinessParent?: boolean;
    leftSideElement?: JSX.Element;
    rightSideElementDesktop?: JSX.Element;
    rightSideElementMobile?: JSX.Element;
    middleContent?: JSX.Element;
    pageTitle: string;
    animationDisabled?: boolean;
    useBorder?: boolean;
}

export const SettingsTopBar = ({
    leftSideElement,
    rightSideElementDesktop,
    rightSideElementMobile,
    isBusinessParent = false,
    middleContent,
    pageTitle,
    animationDisabled = true,
    useBorder = false
}: SettingsTopBarProps) => {
    const LeftPanelElems = [
        <div>
            <PageTitle>{pageTitle}</PageTitle>
        </div>,
        <div>{leftSideElement}</div>
    ];

    const items = React.Children.toArray(LeftPanelElems);
    const LeftPanelSpringRef = useSpringRef();
    const trail = useTrail(items.length, {
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: {
            duration: 500
        },
        ref: LeftPanelSpringRef,
        immediate: animationDisabled
    });

    const timings = animationDisabled ? undefined : [0.5];
    const duration = animationDisabled ? 0 : 2000;

    useChain([LeftPanelSpringRef], timings, duration);

    return (
        <STBWRapper>
            <div>
                <SettingsTopBarTitle $useBorder={useBorder}>
                    {trail.map(({ ...style }, index) => (
                        <a.div key={index} style={style}>
                            <a.div>{items[index]}</a.div>
                        </a.div>
                    ))}
                </SettingsTopBarTitle>
            </div>
            <div>{middleContent}</div>
            {!isBusinessParent && (
                <div>
                    {!!rightSideElementDesktop && <SidebarLayoutShowDesktop>{rightSideElementDesktop}</SidebarLayoutShowDesktop>}
                    <SidebarLayoutShowMobile>
                        <STBMobileRightSidePanel>
                            <div>
                                <V3OpenSettings />
                            </div>
                            {!!rightSideElementMobile && <div>{rightSideElementMobile}</div>}
                        </STBMobileRightSidePanel>
                    </SidebarLayoutShowMobile>
                </div>
            )}
        </STBWRapper>
    );
};
